import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mic, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Voice Bio gate notice — shown in the "Diventa Creator" wizard when the
 * user has not recorded their Voice Bio yet. The CTA deep-links to the
 * existing recorder in the profile edit dialog (no duplication).
 */
const VoiceBioNotice = ({ className = '' }) => {
  const { t } = useTranslation('onboarding');
  return (
    <div
      className={`rounded-xl border border-amber-500/40 bg-amber-500/10 p-4 ${className}`}
      data-testid="audio-avatar-missing-warning"
    >
      <p className="flex items-center gap-2 text-sm font-semibold text-foreground">
        <Mic className="h-4 w-4 shrink-0 gold-text" /> {t('activation_step.voice_bio_title')}
      </p>
      <p className="mt-1.5 text-xs leading-relaxed text-muted-foreground">
        {t('activation_step.voice_bio_body')}
      </p>
      <Button
        asChild
        variant="outline"
        className="mt-3 w-full border-amber-500/40 gold-text hover:bg-amber-500/10 sm:w-auto"
        data-testid="record-voice-bio-cta"
      >
        <Link to="/profile?edit=1&focus=audio-avatar">
          {t('activation_step.voice_bio_cta')} <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
        </Link>
      </Button>
    </div>
  );
};

export default VoiceBioNotice;
